import React from 'react'
import { Dialog, DialogTitle, DialogContent } from '@mui/material'

import QueryBuilderEditor from '@/feature/admin/QueryBuilder/QueryBuilderEditor'
export default class DossierQueryModal extends React.PureComponent {
    constructor(props) {
        super(props)
    }

    render() {
        const kedo = this.props.kedo

        return (
            <Dialog
                maxWidth="xl"
                fullWidth
                open={true}
                onClose={this.props.onClose}
                aria-labelledby="block-form-title"
            >
                <DialogTitle>
                    {this.props.id > 0
                        ? kedo.t('Edit query')
                        : kedo.t('Add query')}
                </DialogTitle>
                <DialogContent>
                    <QueryBuilderEditor
                        id={this.props.id}
                        onSuccess={this.props.onSuccess}
                        onClose={this.props.onClose}
                        ddId={this.props.ddId}
                        kedo={kedo}
                    />
                </DialogContent>
            </Dialog>
        )
    }
}
